import { render, staticRenderFns } from "./dashboard-dialog.vue?vue&type=template&id=42600cff&scoped=true&"
import script from "./dashboard-dialog.vue?vue&type=script&lang=js&"
export * from "./dashboard-dialog.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-dialog.vue?vue&type=style&index=0&id=42600cff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42600cff",
  null
  
)

export default component.exports